import { GenericAction } from "./action-types";

type FormatMoneyType = { amount: string; currencySymbol: string };

type StartupProcesAction = GenericAction<"STARTUP_PROCESS">;

export type { FormatMoneyType, StartupProcesAction };
